/*
 *  -----------------------------------------------------------------------
 *    <copyright file="study-modules.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { useTranslation } from 'hooks';
import { StudyFields } from 'queries/generated/fragments.generated';
import Loading from 'views/components/core/loading';
import 'views/components/admin/studies/admin-study.scss';

interface ICustomStudyFields extends StudyFields {
    _isRAM?: boolean;
    _isCM?: boolean;
    _isCM2?: boolean;
    _isDQ?: boolean;
    _isSM?: boolean;
}

const StudyModules = ({ study }: { study: ICustomStudyFields }) => {
    const { t } = useTranslation();

    if (!study) return <Loading />;

    return (
        <div className="study-settings-wrapper">
            <div className="d-flex">
                <div className="data-wrap">
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:RAMShort')}:</strong>
                        </span>
                        <span className="value">{study._isRAM ? t('active') : ''}</span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:CMLegacyShortWithBrackets')}:</strong>
                        </span>
                        <span className="value">{study._isCM ? t('active') : ''}</span>
                    </div>
                </div>
                <div className="data-wrap">
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:CMShort')}:</strong>
                        </span>
                        <span className="value">{study._isCM2 ? t('active') : ''}</span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:DQ')}:</strong>
                        </span>
                        <span className="value">{study._isDQ ? t('active') : ''}</span>
                    </div>
                    <div className="row">
                        <span className="title">
                            <strong>{t('admin:SMShort')}:</strong>
                        </span>
                        <span className="value">{study._isSM ? t('active') : ''}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudyModules;
